import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { CREDIBILITY_CHECK_RESULT } from '../../lib/constants';
import { CheckIcon, ErrorIcon, NotSubjectIcon } from './CheckIcon';

const CredibilityCheckIcon = ({ checkResult }) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  switch (checkResult) {
    case CREDIBILITY_CHECK_RESULT.ok:
      return (
        <CheckIcon
          msg={formatMessage({
            id: 'credibilityCheckResult.description.msg.ok',
          })}
        />
      );
    case CREDIBILITY_CHECK_RESULT.ng:
      return (
        <ErrorIcon
          msg={formatMessage({
            id: 'credibilityCheckResult.description.msg.ng',
          })}
        />
      );
    case CREDIBILITY_CHECK_RESULT.ng_image:
      return (
        <ErrorIcon
          msg={formatMessage({
            id: 'credibilityCheckResult.description.msg.ng_image',
          })}
        />
      );
    case CREDIBILITY_CHECK_RESULT.ng_date:
      return (
        <ErrorIcon
          msg={formatMessage({
            id: 'credibilityCheckResult.description.msg.ng_date',
          })}
        />
      );
    case CREDIBILITY_CHECK_RESULT.nt:
      return (
        <NotSubjectIcon
          msg={formatMessage({
            id: 'credibilityCheckResult.description.msg.nt',
          })}
        />
      );
    default:
      return null;
  }
};

CredibilityCheckIcon.propTypes = {
  checkResult: PropTypes.number.isRequired,
};

export default CredibilityCheckIcon;
